import React from 'react'

import type { HistoryParticipationType } from '../../BanksParticipation.types'
import Bank from '../Bank/Bank'
import Nothing from '../Nothing/Nothing'
import styles from './BrokenBanks.module.scss'

interface Props {
  historyParticipations: HistoryParticipationType[]
}

const BrokenBanks: React.FC<Props> = ({ historyParticipations }) => {
  return (
    <>
      {historyParticipations.length === 0 && <Nothing />}

      <div className={styles.wrapper}>
        {historyParticipations.map((item: HistoryParticipationType) => {
          return <Bank variant='broken' bank={item} />
        })}
      </div>
    </>
  )
}

export default BrokenBanks
